module.exports = __webpack_public_path__ + "static/welshlogo-e2a29f63dd7b7565a8077400c4d548de.png";